export default `p=sin(2.8*p+5.*sin(p*.3));
    float s=2., e;
    for(int i=0;i++<6;)
      p=abs(p-1.7)-1.5,
      s*=e=2.3/clamp(dot(p,p),.3,1.2),
      p=abs(p)*e;
    return length(p.zy)/s;
  }`